import { render, staticRenderFns } from "./selectorders.vue?vue&type=template&id=1949a39d&"
import script from "./selectorders.vue?vue&type=script&lang=ts&"
export * from "./selectorders.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports